import { ReactNode } from "react"
import cn from "classnames"

interface SubmenuItemProps {
    children: ReactNode
    className?: string
}

export function SubmenuItem({ children, className }: SubmenuItemProps) {
    return <div className={cn("mobile-navigation__submenu-item", className)}>{children}</div>
}
